import { create } from 'zustand';

interface CommandPaletteState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

/**
 * Global open/close state for the command palette. Lives in the
 * repositories layer per AGENTS.md ("state (Zustand stores)").
 */
export const useCommandPalette = create<CommandPaletteState>((set) => ({
  open: false,
  setOpen: (open) => {
    set({ open });
  },
  toggle: () => {
    set((s) => ({ open: !s.open }));
  },
}));
